module.exports = __webpack_public_path__ + "26ca009f590324b6a66738d01b6ed454.png";